// @vendors
const Immutable = require('immutable');
const moment = require('moment');

// @constants
const { FIRST_STEP, SECOND_STEP } = require('constants/index');
const {
    RA_DATEPICKER_MAXIMUM_YEARS,
    RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT,
} = require('../raConstants/index');
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    steps: [
        {
            valid: false,
            goalSelected: false,
            goalTypeSelected: '',
            goalSelectedFlagForRadio: true,
            goals: [
                // Hardcoded the goals content for now.
                {
                    id: 'car',
                    title: 'raSetGoal-goalCoche', //'Coche Nuevo'
                    isSelected: false,
                },
                {
                    id: 'home',
                    title: 'raSetGoal-goalCasa', // 'Mi Casa'
                    isSelected: false,
                },
                {
                    id: 'travel',
                    title: 'raSetGoal-goalViaje', //'Viaje'
                    isSelected: false,
                },
                {
                    id: 'education',
                    title: 'raSetGoal-goalEducacion', //'Estudios',
                    isSelected: false,
                },
                {
                    id: 'others',
                    title: 'raSetGoal-goalOtro', //'Otro'
                    isSelected: false,
                },
            ],
        },
        {
            valid: false,
            errorFlags: false,
            dateError: false,
            getSimulationSucceed: false,
            investmentAmount: 0,
            investmentTitle: '',
            investmentDate: null,
            minDate: moment()
                .startOf('day')
                .add(1, 'day')
                .add(1, 'years'),
            maxDate: moment()
                .startOf('day')
                .add(RA_DATEPICKER_MAXIMUM_YEARS, 'years'),
        },
    ],
    visibleStep: FIRST_STEP,
    submitSuccessful: false,
    isFetching: false,
    isNonresidentialModalOpen: false,
    type: '',
});

function setGoalValues(state, payload) {
    switch (payload.key) {
        case 'investmentAmount':
            const errorFlag =
                payload.value !== 0 &&
                payload.value < RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT;
            return state.mergeIn(['steps', SECOND_STEP], {
                errorFlags: errorFlag,
                [payload.key]: payload.value,
            });
        case 'investmentTitle':
        case 'investmentDate':
            return state.mergeIn(['steps', SECOND_STEP], {
                [payload.key]: payload.value,
                dateError:
                    !payload.value ||
                    payload.value === 'Invalid date' ||
                    (payload.value.isValid && !payload.value.isValid()),
            });
        default:
            return state;
    }
}

function updateGoal(state, data) {
    const selectedId = data.id;
    let goalsData = state.getIn(['steps', FIRST_STEP, 'goals']);
    const goalSelected = state.getIn(['steps', FIRST_STEP, 'goalSelected']);
    const goalSelectedFlagForRadio = state.getIn([
        'steps',
        FIRST_STEP,
        'goalSelectedFlagForRadio',
    ]);

    if (goalSelected && data.isSelected) {
        // To reset imageButtons to initial state if already selected
        return initialState.mergeIn(['steps', FIRST_STEP], {
            goalSelectedFlagForRadio: !goalSelectedFlagForRadio,
        });
    }

    goalsData = goalsData.map(goal => {
        const isSelected = goal.get('id') != selectedId;
        return isSelected
            ? goal.update('isSelected', () => false)
            : goal.update('isSelected', () => true);
    });

    return initialState
        .mergeIn(['steps', FIRST_STEP], {
            goals: goalsData,
            goalTypeSelected: selectedId,
            goalSelected: selectedId !== '',
        })
        .mergeIn(['steps', SECOND_STEP], {
            investmentTitle: data.label || '',
        });
}

const RASetGoal = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_SET_GOAL_GET_DATA_FROM_SIMULATION:
            const immSimulation = action.payload;
            let newState = state;

            newState = updateGoal(newState, {
                id: immSimulation.get('type') || '',
            });
            newState = newState.mergeIn(['steps', SECOND_STEP], {
                investmentAmount: immSimulation.get('amount') || 0,
                investmentTitle: immSimulation.get('name') || '',
                investmentDate: immSimulation.get('endDate')
                    ? moment(immSimulation.get('endDate'))
                    : state.getIn(['steps', SECOND_STEP, 'minDate']),
                errorFlags:
                    immSimulation.get('amount') <
                        RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT &&
                    immSimulation.get('amount') > 0,
                getSimulationSucceed: true,
            });

            return newState;
        case actionTypes.RA_SET_GOAL_RESET:
        case actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET:
            return initialState;
        case actionTypes.RA_SET_GOAL_DATE_ERROR_ENABLED:
            return state.mergeIn(['steps', SECOND_STEP], {
                dateError: true,
            });
        case actionTypes.RA_UPDATE_SELECTED_GOAL:
            const { goalSelected } = action.payload;
            return updateGoal(state, goalSelected);
        case actionTypes.RA_SET_GOAL_SET_VISIBLE_STEP:
            return state.merge({
                visibleStep: action.payload.step,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS:
            const { amount } = action.payload.data;

            let newCustomState = state.mergeIn(['steps', SECOND_STEP], {
                investmentAmount: amount || 0,
                errorFlags:
                    amount < RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT &&
                    amount > 0,
            });

            return newCustomState;
        case actionTypes.RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE:
            return setGoalValues(state, action.payload);
        case actionTypes.RA_NONRESIDENTIAL_MODAL_VALIDATION:
            const residentType = action.payload.profile.get('paisResidencia');
            const originCountry = action.payload.profile.get('originCountry');
            return state.merge({
                isNonresidentialModalOpen:
                    residentType != originCountry ? true : false,
                type: action.payload.type,
            });
        case actionTypes.RA_NONRESIDENTIAL_MODAL_CLOSE:
            return state.merge({
                isNonresidentialModalOpen: false,
            });
        default:
            return state;
    }
};

module.exports = RASetGoal;
